import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { GeotabCall } from "./fetchExceptionEvents";
import { SyncZoneLogRulesInput, syncZoneLogRules } from "./syncZoneLogRules";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useSyncZoneLogRules() {
  const { geotabClient } = useGeotabClient();
  const queryClient = useQueryClient();
  const [progress, setProgress] = useState<{ done: number; total: number }>();

  const mutation = useMutation({
    mutationFn: (input: SyncZoneLogRulesInput) => {
      const call: GeotabCall = (method, params, signal) => geotabClient.call(method, params, signal);
      return syncZoneLogRules(call, input, (done, total) => setProgress({ done, total }));
    },
    // Also after a failure part-way: the rules created before it exist and must not be offered again.
    onSettled: () => {
      setProgress(undefined);
      return queryClient.invalidateQueries({ queryKey: ["zoneLogSetup"] });
    },
  });

  return Object.assign(mutation, { progress });
}
